import React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import { formatPercent } from '../../utils/formatters';

// Progress meter for a credit-progress row.
// Color shifts: red <33%, amber <66%, green ≥66%, teal at 100%.
function colorFor(pct) {
  if (pct >= 100) return '#0d9488';
  if (pct >= 66) return '#16a34a';
  if (pct >= 33) return '#f59e0b';
  return '#dc2626';
}

export default function ProgressMeter({ label, current = 0, required = 0, unit = '' }) {
  const pct = formatPercent(current, required);
  const color = colorFor(pct);

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mb: 0.5 }}>
        <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary' }}>
          {label}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ fontVariantNumeric: 'tabular-nums' }}>
          {current}{unit ? ` ${unit}` : ''} / {required}{unit ? ` ${unit}` : ''}
          <Box component="span" sx={{ ml: 1, color, fontWeight: 600 }}>{pct}%</Box>
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={pct}
        sx={{
          height: 8,
          borderRadius: 4,
          backgroundColor: '#e5e7eb',
          '& .MuiLinearProgress-bar': {
            backgroundColor: color,
            borderRadius: 4,
          },
        }}
      />
    </Box>
  );
}
